import * as React from 'react';
import { Controller } from "./Infraestructure/Controller";
import { ViewMain } from "./Components/View";


const ManagerEntity = () => {
    const controller = Controller();

    React.useEffect(() => {
        controller.onInit();
        return () => {
        }
        // eslint-disable-next-line
    }, []);

    return (<ViewMain {...controller} />);
};

export default ManagerEntity;